module.exports = __webpack_public_path__ + "static/auto_import_395x301-44598dc934b18adbc05f1f9fe061794b.png";